function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.053.218a4.886 4.886 0 0 0 0 9.77c2.688 0 4.874-2.191 4.874-4.886 0-2.693-2.186-4.884-4.874-4.884",
  fill: "#E31F03"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.14 18.993c-2.688 0-4.876 2.191-4.876 4.884 0 2.694 2.188 4.885 4.875 4.885a4.886 4.886 0 0 0 0-9.77",
  fill: "#FF6B01"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.32 12.27a4.886 4.886 0 0 0 4.876 4.885c2.688 0 4.875-2.191 4.875-4.886 0-2.693-2.187-4.884-4.875-4.884A4.886 4.886 0 0 0 .32 12.269z",
  fill: "#297AE4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.9 7.396a4.885 4.885 0 1 0 0 9.77c2.69 0 4.875-2.19 4.875-4.885A4.885 4.885 0 0 0 24.9 7.396",
  fill: "#FFB800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.951 18.993c-2.687 0-4.875 2.191-4.875 4.884 0 2.694 2.188 4.885 4.875 4.885a4.886 4.886 0 0 0 0-9.77",
  fill: "#38AE1B"
}));

var SvgNavLogo = function SvgNavLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NavLogo.fd333a36.svg";
export { ForwardRef as ReactComponent };